type RealtimeSessionUpdate = {
  type: "session.update"
  voice_internal_data_consent?: true
  route_id?: string
  session_type?: string
  session: {
    modalities: ["text", "audio"]
    input_audio_format: "pcm16"
    output_audio_format: "pcm16"
    voice: string
    turn_detection: {
      type: "server_vad"
      threshold: number
      prefix_padding_ms: number
      silence_duration_ms: number
    }
  }
}

export function buildRealtimeSessionUpdate(
  voice: string,
  hasInternalDataConsent: boolean,
  routing: { routeId?: string; sessionType?: string } = {}
): RealtimeSessionUpdate {
  return {
    type: "session.update",
    ...(hasInternalDataConsent ? { voice_internal_data_consent: true as const } : {}),
    ...(routing.routeId ? { route_id: routing.routeId } : {}),
    ...(routing.sessionType ? { session_type: routing.sessionType } : {}),
    session: {
      modalities: ["text", "audio"],
      input_audio_format: "pcm16",
      output_audio_format: "pcm16",
      voice,
      turn_detection: {
        type: "server_vad",
        threshold: 0.5,
        prefix_padding_ms: 300,
        silence_duration_ms: 500,
      },
    },
  }
}
